import _shuffle from "lodash/shuffle";
//
import { _addIf } from "../../utils";

export default {
  setModel(state, action) {
    if (!action.payload) {
      return state;
    }

    return {
      ...state,
      active: action.payload,
    };
  },

  getModelsPending(state, action) {
    return {
      ...state,
      unavailable: [],
      online: [],
      offline: [],
      visible: "online",
    };
  },

  getModelsFullfilled(state, { payload }) {
    const { result } = payload;

    return {
      ...state,
      entities: getModels(state, payload),
      online: result,
      onlineCount: result.length,
    };
  },

  countModelsFullfilled(state, action) {
    return {
      ...state,
      onlineCount: action.payload,
    };
  },

  getModelsOfflineFullfilled(state, { payload }) {
    const { result } = payload;

    return {
      ...state,
      entities: getModels(state, payload),
      unavailable: [],
      offline: result,
    };
  },

  getModelsFavoriteFullfilled(state, { payload }) {
    return {
      ...state,
      entities: getModels(state, payload),
      favoriteLoaded: true,
      favorite: payload.result,
    };
  },

  getVideosFullfilled(state, { payload }) {
    return {
      ...state,
      entities: getModels(state, payload),
    };
  },

  getModelFullfilled(state, { payload }) {
    return {
      ...state,
      entities: getModels(state, payload),
    };
  },

  modelUnavailableError(state, action) {
    if (action.payload.error !== "model_unavailable") {
      return state;
    }

    const { active, unavailable } = state;

    return {
      ...state,
      unavailable: _addIf(unavailable, active),
    };
  },

  favoriteModel(state, action) {
    return {
      ...state,
      favorite: state.favorite.concat(action.payload),
    };
  },

  unfavoriteModel(state, action) {
    return {
      ...state,
      favorite: state.favorite.filter((id) => id !== action.payload),
    };
  },

  setUser(state, action) {
    const user = action.payload;

    return {
      ...state,
      favorite: user.models,
    };
  },

  setModelsVisible(state, action) {
    return {
      ...state,
      visible: action.payload,
    };
  },

  changeDuration(state, action) {
    return {
      ...state,
      unavailable: [],
      online: state.active ? [state.active] : [],
      offline: [],
      favorite: [],
      favoriteLoaded: false,
      onlineCount: null,
    };
  },

  getReviewsFulfilled(state, action) {
    const { active, entities } = state;
    const { result } = action.payload;

    const model = entities[active];
    model.reviews = model.reviews.concat(result);

    return {
      ...state,
      entities: {
        ...entities,
        [active]: model,
      },
    };
  },

  showScreen(state, { payload: screen }) {
    if (screen === "models") {
      return {
        ...state,
        active: null,
      };
    }

    return state;
  },

  editSearch(state) {
    return {
      ...state,
      active: null,
      areaId: null,
    };
  },

  reset(state) {
    return {
      ...state,
      active: null,
      online: [],
      offline: [],
      favorite: [],
      favoriteLoaded: false,
    };
  },

  setArea(state, { payload }) {
    return {
      ...state,
      areaId: payload,
    };
  },
};

// Local helpers
function getModels(state, { entities }) {
  const models = { ...state.entities };

  Object.keys(entities.models || {}).forEach((id) => {
    if (models[id]) {
      // Merge
      Object.assign(models[id], entities.models[id]);
    } else {
      models[id] = entities.models[id];
    }
  });

  return models;
}
